import { Button } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import withAdminLayout from "components/HoC/withAdminLayout";

function HomeAdminPage() {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <h2>{t("title")}</h2>
      <Button
        onClick={() => {
          i18n.changeLanguage("th");
        }}
      >
        TH
      </Button>
      <Button
        onClick={() => {
          i18n.changeLanguage("en");
        }}
      >
        EN
      </Button>
    </div>
  );
}

export default withAdminLayout(HomeAdminPage);
